import * as React from 'react'
import { useIntl } from 'react-intl'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import { Box, DialogActions } from '@mui/material'

interface Props {
    open: boolean
    confirmAction: () => void
}

const ExamFinishedDialog: React.FC<Props> = ({ confirmAction, open }) => {
    const { formatMessage } = useIntl()

    return (
        <Dialog
            maxWidth={'sm'}
            fullWidth
            open={open}
        >
            <DialogTitle textAlign={'center'}>
                <Box>
                    <CheckCircleIcon
                        color={'secondary'}
                        sx={{ color: 'secondary', fontSize: '40px' }}
                    />
                </Box>
                {formatMessage({ id: 'examFinished' })}
            </DialogTitle>

            <DialogContent>
                <DialogContentText textAlign={'center'}>
                    {formatMessage({ id: 'exam_finished' })}
                </DialogContentText>
            </DialogContent>

            <DialogActions
                sx={{
                    mb: 2,
                    justifyContent: 'center',
                    display: 'grid',
                    gap: '8px',
                }}
            >
                {/* <Button
                    variant="outlined"
                    // onClick={handleClose}
                    fullWidth
                >
                    {formatMessage({ id: 'baсk_to_course' })}
                </Button> */}

                <Button
                    variant="contained"
                    fullWidth
                    onClick={() => {
                        confirmAction()
                    }}
                >
                    {formatMessage({ id: 'back' })}
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default ExamFinishedDialog
